<template>
    <span class="label" :color="color" :textColor="textColor" :size="size">
        <slot></slot>
    </span>
</template>

<script>
    let sizes = ['default'];

    export default {
        name: "label",
        props: {
            type: {
                type: String,
                default: 'default'
            },
            size : {
                type: String,
                default: 'default',

            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../assets/scss/main';

    .label {
        display: inline-block;
        font-family: $font-paragraphs;
        font-size: 1rem;
        text-decoration: none;
        border-radius: 26px;
        border: none;
        padding: 0 1.25em;
        color: white;
        background-color: $mine-shaft;

        &[size="default"] {
            font-size: 12px;
            min-width: 93px;
            height: 31px;
            line-height: 31px;
            padding: 0 17px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/Label.vue